import {
  extractA2uiTextFromObject,
  isA2uiV08BotReplyPayload,
} from './isA2uiV08BotReplyPayload';

function trimString(s) {
  return typeof s === 'string' ? s.trim() : '';
}

/**
 * 若輸入為合法 A2UI v0.8 訊息序列（或包在 API 物件／JSON 字串內），解析出 surfaceId 與 messages。
 * @param {unknown} input
 * @returns {{ surfaceId: string, messages: unknown[] } | null}
 */
export function parseA2uiV08MessagesFromPayload(input) {
  try {
    let arr = null;

    if (typeof input === 'string') {
      const s = trimString(input);
      if (s === '') return null;
      try {
        const outer = JSON.parse(s);
        if (Array.isArray(outer)) arr = outer;
        else if (outer && typeof outer === 'object' && !Array.isArray(outer)) {
          const innerText = extractA2uiTextFromObject(outer);
          if (!innerText) return null;
          arr = JSON.parse(innerText);
        }
      } catch {
        return null;
      }
    } else if (Array.isArray(input)) {
      arr = input;
    } else if (input && typeof input === 'object') {
      const innerText = extractA2uiTextFromObject(input);
      if (!innerText) return null;
      try {
        arr = JSON.parse(innerText);
      } catch {
        return null;
      }
    }

    if (!Array.isArray(arr) || arr.length === 0) return null;
    if (!isA2uiV08BotReplyPayload(arr)) return null;

    let surfaceId = null;
    for (const m of arr) {
      const sid = m?.beginRendering?.surfaceId;
      if (typeof sid === 'string' && sid.trim() !== '') {
        surfaceId = sid;
        break;
      }
    }
    if (!surfaceId) return null;

    return { surfaceId, messages: arr };
  } catch {
    return null;
  }
}
